import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CcdlButtonComponent,
  CcdlCheckboxComponent,
  CcdlInputComponent,
  CcdlLinkComponent,
  ErrorConfig,
} from '@cpm-pr1618001/ng-design-lib';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sign-in-ui',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  imports: [
    ReactiveFormsModule,
    CcdlLinkComponent,
    CcdlButtonComponent,
    CcdlCheckboxComponent,
    CcdlInputComponent,
  ],
  standalone: true,
})
export class SignInComponent implements OnInit, OnDestroy {
  @Input() signInForm!: FormGroup;

  @Output() forgotPasswordEmitter: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() signUpViewEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output() signInSubmitEmitter: EventEmitter<void> = new EventEmitter<void>();

  emailErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid email.',
  };

  passwordErrorConfig: ErrorConfig = {
    invalid: 'Please enter valid password.',
  };

  subscription: Subscription = new Subscription();

  isSubmitTriggered: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  getControl(controlName: string): FormControl {
    return this.signInForm.get(controlName) as FormControl;
  }

  signInSubmitClick(): void {
    this.signInSubmitEmitter.emit();
    this.isSubmitTriggered = true;
  }

  forgotPasswordClick(): void {
    this.forgotPasswordEmitter.emit();
  }

  signUpViewClick() {
    this.signUpViewEmitter.emit();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
